import styled from 'styled-components';

export const ProfileStatus = styled.div`
  font-size: 1.2rem;
  font-weight: 400;
  color: var(--color-gray3);
  grid-area: status;
`;
